/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  ADD_BREADCRUMB,
  SELECT_BREADCRUMB,
  SET_BREADCRUMBS,
  SET_HOME_BREADCRUMB,
  POP_LAST_BREADCRUMB,
} from './actionTypes'

export function addBreadCrumb(item) {
  return {
    type: ADD_BREADCRUMB,
    item: item,
  }
}

export function popBreadCrumb() {
  return {
    type: POP_LAST_BREADCRUMB,
  }
}

export function selectBreadCrumb(item) {
  return {
    type: SELECT_BREADCRUMB,
    item: item,
  }
}

export function setBreadCrumbs(items) {
  return {
    type: SET_BREADCRUMBS,
    items: items,
  }
}

export function setHomeBreadCrumb(item) {
  return {
    type: SET_HOME_BREADCRUMB,
    item: item,
  }
}